let prepend_to_element = (actionData) => {
    let $el = $(actionData.selector);
    $el.prepend(actionData.html);
};
export default prepend_to_element;